// extracted by mini-css-extract-plugin
export var closeButton = "_2n-3";
export var header = "_2n-0";
export var link = "_2n-1";
export var retryButton = "_2n-2";